import { render } from "./CarSalesVehicle.vue?vue&type=template&id=870b40fe"
import script from "./CarSalesVehicle.vue?vue&type=script&lang=js"
export * from "./CarSalesVehicle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/CarSalesVehicle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "870b40fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('870b40fe', __exports__)) {
    api.reload('870b40fe', __exports__)
  }
  
  module.hot.accept("./CarSalesVehicle.vue?vue&type=template&id=870b40fe", () => {
    api.rerender('870b40fe', render)
  })

}


export default __exports__